import { AnchorButton, Button, Classes } from '@blueprintjs/core';
import * as React from 'react';
import { getIntentClassName } from 'vet-bones/utils';

import { TEST_IDS } from 'src/constants/testIds';
import { useProjectBaseSettings } from 'src/containers/ProjectSettingsDrawer/hooks/useProjectBaseSettingsValue';
import { useProjectModelSettings } from 'src/containers/ProjectSettingsDrawer/hooks/useProjectModelSettingsValue';
import { useProjectSettingsValidation } from 'src/containers/ProjectSettingsDrawer/hooks/useProjectSettingsValidationValue';
import { useSaveProjectSettings } from 'src/containers/ProjectSettingsDrawer/hooks/useSaveProjectSettings';
import { uiSlice } from 'src/store/ui/ui.slice';
import * as copy from 'src/templates/copy';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';

export const ProjectSettingsDrawerFooter: React.VFC = () => {
  const dispatch = useReduxDispatch();
  const { validation } = useProjectSettingsValidation();
  const { handleResetBaseSettings } = useProjectBaseSettings();
  const { handleResetModelSettings } = useProjectModelSettings();

  const isValid =
    validation.name &&
    validation.namespace &&
    Object.values(validation.modelNamespaces).every((item) => item) &&
    Object.values(validation.modelPrefixes).every((item) => item);

  const onClose = () => {
    handleResetBaseSettings();
    handleResetModelSettings();
    dispatch(uiSlice.actions.toggledProjectSettingsDrawer({ isOpen: false }));
  };

  const onSubmit = useSaveProjectSettings();

  return (
    <div className={Classes.DRAWER_FOOTER}>
      <div className="sd-drawer-footer-actions">
        <Button
          data-testid={TEST_IDS.projectSettingsDrawer.cancelButton}
          onClick={onClose}
          outlined
          text={copy.components.projectSettingsDrawer.cancel}
        />
        <AnchorButton
          className={getIntentClassName('sd-green')}
          data-testid={TEST_IDS.projectSettingsDrawer.submitButton}
          disabled={!isValid}
          onClick={onSubmit}
          text={copy.components.projectSettingsDrawer.submit}
        />
      </div>
    </div>
  );
};
